import { ofType } from 'redux-observable';
import { ajax } from 'rxjs/ajax';
import { of } from 'rxjs';
import { map, switchMap, catchError } from 'rxjs/operators';
import { dateOptionsCriteria, boundariesCriteria } from '../../../utilities/epic-helpers';

import {
  FETCH_INSIGHTS_FOOTFALL_PERCENTAGE,
  FETCH_INSIGHTS_FOOTFALL_PERCENTAGE_ERROR,
  SET_INSIGHTS_FOOTFALL_PERCENTAGE
} from '../../constants';


const insightsPercentage = (action$, state$) =>
  action$.pipe(
    ofType(FETCH_INSIGHTS_FOOTFALL_PERCENTAGE),
    switchMap(() =>
      ajax({
        url: `${state$.value.auth.server}/report/${
          state$.value.insightsCriteria.insightType === 'organisation' &&
            state$.value.insightsCriteria.organisation.value !== null
            ? `organisation-footfall-as-percentage-of-category?organisationId=${
            state$.value.insightsCriteria.organisation.value
            }`
            : ''
          }${
          boundariesCriteria(state$)
          }${
          dateOptionsCriteria(state$, 'footfall')
          }&v=${process.env.REACT_APP_VERSION}`,
        headers: {
          Authorization: state$.value.auth.token,
        },
        responseType: 'json',
        crossDomain: true,
      }).pipe(
        map(response => {
          return {
            type: SET_INSIGHTS_FOOTFALL_PERCENTAGE,
            data: response.response,
          };
        }),
        catchError(error =>
          of({
            type: FETCH_INSIGHTS_FOOTFALL_PERCENTAGE_ERROR,
            error,
          })
        )
      )
    )
  );

export default insightsPercentage;
